import { render, staticRenderFns } from "./SolarSystem.vue?vue&type=template&id=171d5126&"
import script from "./SolarSystem.vue?vue&type=script&lang=js&"
export * from "./SolarSystem.vue?vue&type=script&lang=js&"
import style0 from "./SolarSystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports